// extracted by mini-css-extract-plugin
export default {"capitalize":"templateList_capitalize__+vv4H"};